<template>
  <v-container fluid fill-height class="justify-center">
      <v-col >
        <v-card min-height="50vh"
                flat
                :color=" this.$vuetify.theme.dark ? '#121212' : '#fff'"
        >
          <v-card-title class="justify-center">
              <v-toolbar-title class="text-h4 font-weight-bold">
                <img :src=logoImg
                     width="30"
                     @click="onChrome()"
                >
                영어문
              </v-toolbar-title>
          </v-card-title>
          <v-card-subtitle class="my-1">
            <v-row class="row g-1" justify="center">
              {{ $t('login_instruction') }}
            </v-row>
          </v-card-subtitle>
          <v-card-actions>
            <v-col>
              <v-row class="row g-1" justify="center">
                <a type="button" style="width: 200px;"
                   :href="getSocialLoginUrl('kakao')">
                  <img :src="`${app.cdnUrl}/website/button/kakao-signin-korean.png`"
                         type="button" width="200" height="40"
                       alt="kakaoLogin"
                  />
                </a>
              </v-row>
              <v-row class="row g-1" justify="center">
                <a type="button" style="width: 200px"
                   :href="getSocialLoginUrl('google')">
                  <img :src="`${app.cdnUrl}/website/button/google-signin-korean.png`"
                         type="button" width="200" height="40"
                   alt="googleLogin"/>
                </a>
              </v-row>
              <v-row class="row g-1" justify="center">
                <a type="button" style="width: 200px"
                   :href="getSocialLoginUrl('naver')">
                  <img :src="`${app.cdnUrl}/website/button/naver-signin-korean.png`"
                         type="button" width="200" height="40"
                       style="border-radius: 5px"
                       alt="naverLogin"
                  />
                </a>
              </v-row>
              <!-- <v-row class="row g-2" justify="center">
                <a type="button" style="width: 200px"
                   :href="getSocialLoginUrl('facebook')">
                  <img type="button" width="200" height="40"
                       src="https://do-en9door-s3.sgp1.cdn.digitaloceanspaces.com/website/button/facebook-signin-korean.png"/>
                </a>
              </v-row>
              <v-row>
                facebook 로그인 기능은 테스트 중 입니다.
              </v-row> -->

              <v-row v-if="isMobile"
                     class="row g-2 text-center justify-center" justify="center"
                     @click="onChrome()">
                <v-col cols="12">
                  <v-alert
                    outlined
                    dense
                    type="error"
                  >
                    Safari, Chrome 등<br>
                    인터넷 브라우저 이용 부탁드립니다. <br>
                  </v-alert>
                </v-col>
                <v-col cols="12">
                  <v-btn color="error"
                  >기본 브라우저로 연결</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-col>
  </v-container>
</template>

<script>
import apiAccount from "@/api/modules/api-account";
import Cookies from 'vue-cookies/vue-cookies'
import {mapGetters} from "vuex";

export default {
  name: 'Login',
  components: {},
  data() {
    return {
      loading: false,
      showDialog: false,
      redirect: '',
      googleLoginLink: '',
      mobileDeviceType: ''
    }
  },
  computed: {
    ...mapGetters(['app', 'isMobile']),
    logoImg: function () {
      if (this.$vuetify.theme.dark) {
        return `${this.app.cdnUrl}/website/logo/en9door_dark.png`
      } else {
        return `${this.app.cdnUrl}/website/logo/en9door.png`
      }
    }
  },
  created() {
    this.redirect = this.$route.query.redirect
    window.scrollTo(0,0);
  },
  mounted() {
    if(this.redirect) {
      Cookies.set('redirect', this.redirect);
    }
  },
  destroyed() {
  },
  methods: {
    onChrome() {
      const url = process.env.VUE_APP_BASE;
      
      if (navigator.userAgent.match(/iPhone|iPad/i)) {
        // iOS - Try to open in Chrome
        // window.location.href = `googlechrome://${url}`;
        window.location.href = `com-apple-mobilesafari-tab://${url}`;

        // Fallback to Safari after a short delay
        setTimeout(() => {
          window.location.href = url;
        }, 2000);
      } else if (navigator.userAgent.match(/Android/i)) {
        // Android - Try to open in default browser
        window.location.href = `intent://${url}#Intent;scheme=https;package=com.android.chrome;end`;
        // Fallback to default browser
        setTimeout(() => {
          window.location.href = url;
        }, 2000);
      } else {
        // Desktop or other devices
        window.location.href = url;
      }
    },
    getSocialLoginUrl(socialType) {
      this.$cookies.keys().forEach(cookie => this.$cookies.remove(cookie));

      return apiAccount.getSocialLoginUrl(socialType, this.redirect)
    }
  }
}
</script>

